import i from './money-loan-tnc-dialog.container';

export default i;
